import { useTranslation } from 'react-i18next'

import { LanguageCode } from 'meta/app/translate'

export const useCurrentLanguage = (): LanguageCode => {
  const i18n = useTranslation().i18n
  return (i18n?.language?.substring(0, 2) as LanguageCode) ?? LanguageCode.it
}
